var map = {
	"./background.webp": 20552,
	"./bucket.webp": 46234,
	"./heart-empty.webp": 83489,
	"./heart-full.webp": 56869,
	"./lvl-up.png": 59237,
	"./oof.png": 54984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3672;